import request from '@/router/axios'
import env from '@/config/env'

export const queryDirverNearbyPage = (data) => {
  return request({
    url: env.ferryUrl + '/userBlack/page',
    method: 'POST',
    data
  })
}
